import { isEqual } from "lodash";
import { ResolvedTheme } from "@/theme/themeDomain";
import { QueryParams } from "@/utils/queryParams";
import { filterParams, filterQueryParams, Params } from "./filterDomain";

export type PageRoute = { name: string; path: string; params: Params; queryParams: QueryParams };

export type BrowserInfo = {
  theme: ResolvedTheme;
  userAgent: string;
  viewport: { width: number; height: number };
  screen: { width: number; height: number; pixelRatio: number };
};

export type PageViewData = BrowserInfo & {
  route: string;
  path: string;
  params: Record<string, string>;
  queryParams: QueryParams;
  navigation: "load" | "route";
};

export function readBrowserInfo(): BrowserInfo {
  return {
    theme: appliedTheme(),
    userAgent: navigator.userAgent,
    viewport: { width: window.innerWidth, height: window.innerHeight },
    screen: { width: screen.width, height: screen.height, pixelRatio: window.devicePixelRatio },
  };
}

function appliedTheme(): ResolvedTheme {
  const applied = document.documentElement.dataset.theme;
  if (applied === "light" || applied === "dark") {
    return applied;
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function isSamePage(previous: PageRoute | undefined, route: PageRoute): boolean {
  return (
    previous?.name === route.name &&
    isEqual(previous.params, route.params) &&
    isEqual(previous.queryParams, route.queryParams)
  );
}

export function toPageViewData(
  route: PageRoute,
  previous: PageRoute | undefined,
  browser: BrowserInfo,
): PageViewData {
  return {
    route: route.name,
    path: route.path,
    params: filterParams(route.params),
    queryParams: filterQueryParams(route.queryParams),
    navigation: previous ? "route" : "load",
    ...browser,
  };
}
